import React, { useEffect, useContext, useState } from "react";
import { SuperSEO } from "react-super-seo";
import axios from "axios";
import { Card, Col, ListGroup, Row } from "react-bootstrap";
import PsContext from "../../context";

const NotFound = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  return (
    <>
      <section>
        <div className="head-2">
          <div className="container">
            <div className="head-2-inn head-2-inn-padd-top">
              <h1>Page Not Found</h1>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
